import styles from "./home-layout.module.scss";
import classNames from "classnames";
import React, { Suspense, useState, useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { UserAuthModel } from "@models/authorization.models";
import { Sidebar } from "@home/layouts/home-layout/components/sidebar/sidebar";
import { Header } from "@home/layouts/home-layout/components/header/header";
import { Progress } from "@home/layouts/home-layout/components/progress/progress";
// import { FleetTabsHeader } from "@modules/home/pages/fleet-page/components/fleet-tabs-header";
import { isMobile } from "react-device-detect";

interface HomeLayoutProps {
  currentUser: UserAuthModel;
}

const shouldShowFleetTabs = (pathname: string): boolean => {
  const p = pathname.toLowerCase();
  return (
    p.startsWith("/fleet") ||
    p.startsWith("/damage") ||
    p.startsWith("/incidents") ||
    p.startsWith("/metrics-upload") ||
    p.startsWith("/teamscorecard") ||
    p.startsWith("/driver-scorecard") ||
    p.startsWith("/auto-roster")
  );
};

export const HomeLayout: React.FC<HomeLayoutProps> = ({
  currentUser,
  children,
}) => {
  const [sidebarOpen, setSidebar] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const handleSidebarState = useCallback(() => {
    setSidebar(!sidebarOpen);
  }, [sidebarOpen]);

  useEffect(() => {
    return history.listen(() => {
      if (sidebarOpen) {
        handleSidebarState();
      }
    });
  }, [handleSidebarState, history, sidebarOpen]);

  const showFleetTabs = shouldShowFleetTabs(location.pathname);

  return (
    <div className={styles.Container}>
      <Sidebar
        open={sidebarOpen}
        onSidebarClose={handleSidebarState}
        currentUser={currentUser}
      />
      <div
        className={classNames(styles.Content, { [styles.IsMobile]: isMobile })}
      >
        <Header
          onMobileIconClick={handleSidebarState}
          currentUser={currentUser}
        />
        {/* {showFleetTabs && (
          <div style={{ padding: isMobile ? "12px 12px 0 12px" : "24px 24px 0 24px", width: "100%", boxSizing: "border-box" }}>
            <FleetTabsHeader />
          </div>
        )} */}
        <Suspense fallback={<Progress />}>{children}</Suspense>
      </div>
    </div>
  );
};
